import React, { useContext } from "react";

import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import TravelTable from "./TravelTable";
import { context } from "../../context/context";
const Travel = () => {
    // context
    const {
        setTravelContent,
        setTravelCover,
        setTravelCoverId,
        setTravelGeo,
        setTravelMedia,
        setTravelMediaId,
        setTravelPlaces,
        setTravelTags,
        setTravelTime,
        setTravelTitle,
        setSelectedTravelId,
        setTextEditorHTML,
    } = useContext(context);
    // functions
    const handleEmpty = () => {
        setTravelContent([]);
        setTravelCover([]);
        setTravelCoverId();
        setTravelGeo([]);
        setTravelMedia([]);
        setTravelMediaId([]);
        setTravelPlaces([]);
        setTravelTags([]);
        setTravelTime([]);
        setTravelTitle([]);
        setSelectedTravelId();
        setTextEditorHTML("");
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addTravelSuggestion">
                    <Button onClick={handleEmpty} type="primary">
                        اضافه کردن پیشنهاد سفر جدید
                    </Button>
                </NavLink>
            </Space>
            <TravelTable />
        </>
    );
};

export default Travel;
